import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';
import { textGray } from '../utils/colors';

const StyledAction = styled.a`
  display: inline-flex;
  line-height: 1.25em;
  font-weight: 600;
  color: ${props => props.theme.tertiary};
  text-decoration: none;
  margin: 0.6875em 0;
  align-items: center;

  &:hover {
    color: ${textGray};
  }
`;

const ActionLink = StyledAction.withComponent(Link);

const Icon = styled.i`
  display: block;
  margin-right: 0.6875em;

  ${props =>
    props.rotateIcon &&
    css`
      transform: rotate(180deg);
    `};

  ${props =>
    props.position === 'right' &&
    css`
      margin-right: 0;
      margin-left: 0.6875em;
      order: 1;
    `};

  svg {
    display: block;
  }

  .svg-fill-color {
    fill: ${textGray};
  }

  .svg-stroke-color {
    stroke: ${textGray};
  }
`;

const Action = ({
  icon,
  children,
  href = null,
  to = null,
  iconPosition = 'left',
  rotateIcon = false
}) => {
  const Component = href !== null ? StyledAction : ActionLink;

  return (
    <Component
      href={href}
      to={to}
      target={href !== null ? '_blank' : null}
      rel={href !== null ? 'noopener' : null}
    >
      {icon && (
        <Icon rotateIcon={rotateIcon} position={iconPosition}>
          {icon}
        </Icon>
      )}
      {children}
    </Component>
  );
};

Action.propTypes = {
  icon: PropTypes.element,
  href: PropTypes.string,
  to: PropTypes.string,
  iconPosition: PropTypes.oneOf(['left', 'right']),
  rotateIcon: PropTypes.bool
};

export default Action;



// WEBPACK FOOTER //
// ./src/components/Action.js